import {
  actionCreator,
  checkHttpStatus,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  DomainActionTypes,
  GET_DOMAIN_LIST_API,
  POST_DOMAIN_API,
  GET_DOMAIN_DETAILS_API,
  DELETE_DOMAIN_API,
  GET_MASTERDATABYNAME
} from '../constants/ApiConstants';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI, showWarningMessage } from '../../../../../../actions/utilAction';


export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(DomainActionTypes.get_master_data.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(DomainActionTypes.get_master_data.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getMasterData...', error);
      });
  };
};

export const getDomainList = (searchObj, curriculumLibraryIdForDomain) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(DomainActionTypes.get_domainList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_DOMAIN_LIST_API}${query_params}&curriculumLibraryId=${curriculumLibraryIdForDomain}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(DomainActionTypes.get_domainList.SUCCESS, response));
        } else {
          dispatch(actionCreator(DomainActionTypes.get_domainList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_domainList ', error);
      });
  };
};

export const saveDomain = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(DomainActionTypes.post_domain.REQUEST));
    fetch(POST_DOMAIN_API, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(DomainActionTypes.post_domain.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(DomainActionTypes.post_domain.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_domain', error);
      });
  };
};

export const getDomainDetails = (domainID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(DomainActionTypes.get_domainDetails.REQUEST));
    fetch(`${GET_DOMAIN_DETAILS_API}?domainId=${domainID}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(DomainActionTypes.get_domainDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(DomainActionTypes.get_domainDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_domainDetails ', error);
      });
  };
};

export const deleteDomain = (domainID) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(DomainActionTypes.delete_domain.REQUEST));
    fetch(`${DELETE_DOMAIN_API}?domainId=${domainID}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200 || response.statusCode === 204) { 
          showSuccessMessage(response.message);
          dispatch(actionCreator(DomainActionTypes.delete_domain.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(DomainActionTypes.delete_domain.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(DomainActionTypes.delete_domain.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error delete_domain', error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/domain/actions/domainActions.js